// useResolveQuery Hook
import { useState, useCallback, useMemo } from "react";
import { QueryEntity } from "../../domain/entities/QueryEntity";
import { ResolveQueryUseCase } from "../../domain/use-cases/ResolveQueryUseCase";
import { QueriesRepositoryImpl } from "../../data/repositories/QueriesRepositoryImpl";
import { queriesApi } from "../../data/api/queriesApi";
import { Result } from "../../domain/common/Result";

export const useResolveQuery = () => {
  const [resolving, setResolving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Instantiate repository and use case
  const repository = useMemo(
    () => new QueriesRepositoryImpl(queriesApi),
    []
  );

  const resolveQueryUseCase = useMemo(
    () => new ResolveQueryUseCase(repository),
    [repository]
  );

  const resolve = useCallback(
    async (queryId: number): Promise<Result<QueryEntity>> => {
      setResolving(true);
      setError(null);

      const result = await resolveQueryUseCase.execute(queryId);

      if (result.isFailure) {
        setError(result.error);
      }

      setResolving(false);
      return result;
    },
    [resolveQueryUseCase]
  );

  return {
    resolve,
    resolving,
    error,
  };
};

